import type {CSSProperties} from 'react';

/** Must render above `@ds` Modal (`--z-index-modal`: 10000). */
export const DATE_PICKER_POPUP_Z_INDEX = 10050;

/** Fixed shell aligned with `body` max-width — not full viewport on desktop. */
export const APP_POPUP_CONTAINER_ID = 'app-popup-container';

/** Portal target for picker popups (480px column, overflow visible). */
export function getDatePickerPopupContainer(): HTMLElement {
  let container = document.getElementById(APP_POPUP_CONTAINER_ID);

  if (!container) {
    container = document.createElement('div');
    container.id = APP_POPUP_CONTAINER_ID;
    document.body.appendChild(container);
  }

  return container;
}

export function mergePickerPopupStyles(
  stylesProp?: Record<string, CSSProperties | undefined>
): Record<string, CSSProperties | undefined> {
  return {
    ...stylesProp,
    popup: {
      ...stylesProp?.popup,
      zIndex: stylesProp?.popup?.zIndex ?? DATE_PICKER_POPUP_Z_INDEX
    }
  };
}
